import { Box, Flex, Table, Tbody, Td, Tr } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const LogDailySkeleton = () => {
  return (
    <Box className={styles['log-daily-skeleton__container']} flex={1}>
      <Flex mb="12px" justifyContent="space-between" alignItems="center">
        <SkeletonComponent width="91px" height="23px" />
        <SkeletonComponent width="91px" height="24px" />
      </Flex>

      <Box className={styles['log-daily-skeleton__box']}>
        <Table>
          <Tbody>
            <Iteration
              items={[1, 2, 3, 4, 5]}
              render={(idx) => (
                <Tr key={idx}>
                  <Td>
                    <SkeletonComponent width="90%" height="18px" />
                  </Td>
                  <Td>
                    <SkeletonComponent width="90%" height="18px" />
                  </Td>
                  <Td>
                    <SkeletonComponent width="90%" height="18px" />
                  </Td>
                  <Td>
                    <SkeletonComponent width="90%" height="18px" />
                  </Td>
                </Tr>
              )}
            />
          </Tbody>
        </Table>
      </Box>
    </Box>
  );
};

export default LogDailySkeleton;
